import { ACCOUNT } from './Account';

export const query = {
  ACCOUNT,
};
